import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import '../../App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './DaynamicPage.css';

const Plans = () => {
    const [plansData, setPlansData] = useState([])


    const getPlanData = () => {
        axios.get("https://backend.mayiservicespvtltd.com/api/plans.php?slug=getPlans")
            .then((res) => {
                if (res.data.status) {
                    setPlansData(res.data.data)
                } else {
                    setPlansData([])
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    useEffect(() => {
        getPlanData()
    }, [])
    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, []);

    const userData = JSON.parse(localStorage.getItem('mayiservice_user'));


    const navigate = useNavigate()

    const payAmount = (el) =>{
        console.log(el);
        // if(!userData){
        //     navigate('/log-in')
        // } else {
        //     loadRazorpay(el)
        // }
    }

      const loadRazorpay = (el) => {
    const options = {
      key: "rzp_test_1DP5mmOlF5G5ag", // Replace with your Key ID from Razorpay Dashboard
      amount: el?.amount * 100, // Razorpay works in paise (1₹ = 100 paise)
      currency: "INR",
      name: el?.title ? `${el?.title} - May I Services` : "May I Services Pvt Ltd",
      description: el?.content ? `${el?.content} - May I Services` : "May I Services Pvt Ltd",
      image: el?.image, // optional
      handler: function (response) {
        alert("Payment ID: " + response.razorpay_payment_id);
        // you can call backend API here to verify the payment
      },
      prefill: {
        name: userData?.user?.name ,
        email: userData?.user?.username ,
        contact: userData?.user?.mobile ,
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
    return (
        <div>
            {
                plansData &&
                <div className='col-11 m-auto row  justify-content-center' >
                    {plansData.map((el, index) => (
                        <div className='col-lg-4 col-md-6 mt-4' key={index} data-aos="fade-up">
                            <div className='col-11 m-auto bgdmg rounded-4 h-100'>
                                <div className='p-3'>
                                    <img src={el?.image || el?.video_url} style={{ width: '100%' }} className='rounded-4' alt="" />
                                </div>
                                <div className='col-11 m-auto mt-4'>
                                    {el?.title && <p className='fs-2 fw-bold lmg ' >{el?.title}</p>}
                                    {el?.content && <p className='lmg'  dangerouslySetInnerHTML={{ __html: el?.content }}></p>}
                                    {el?.amount && <p className='fs-5 lmg fw-bold' >{el?.amount} ₹</p>}
                                    {el?.button_text  && (
                                        <div className="d-flex m-auto gap-3 align-items-center justify-content-center" >
                                            {el?.button_text && (
                                                <button className="btn btn-outline-light rounded-5 mt-2" onClick={()=>payAmount(el)} > {el.button_text} </button>
                                            )}
                                        </div>
                                    )}
                                    <br />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            <br />
        </div>
    )
}

export default Plans